import React, {memo} from "react";

export const IconArrowTop = memo(({color}) => {
  return (
    <svg
      width="19"
      height="11"
      viewBox="0 0 19 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.34375e-05 9.99998C2.34375e-05 10.128 0.0490234 10.256 0.146023 10.354C0.341023 10.549 0.658023 10.549 0.853023 10.354L9.49902 1.70798L18.145 10.354C18.34 10.549 18.657 10.549 18.852 10.354C19.047 10.159 19.047 9.84198 18.852 9.64698L9.85202 0.646982C9.65702 0.451982 9.34002 0.451982 9.14502 0.646982L0.145023 9.64698C0.0470234 9.74498 -0.000976562 9.87298 -0.000976562 10.001L2.34375e-05 9.99998Z"
        fill={color || "#C17E2E"}
      />
    </svg>
  );
});
